export default {
  id: 'ClassDescriptionModal',
  code: 'CN',
  text: {
    'Class Description': '班级简介',
    'Save': '保存',
    'Cancel': '取消',
    'Description': '简介',
    'Do you want to display this on website': '是否要在官网上展示'

  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/ClassDescription/locale.js